import React, { useState, useEffect } from 'react'
import { Input, Dropdown } from 'semantic-ui-react';
import CurrencyFormat from 'react-currency-format';

import Results from './Results';

function Calculator() {

  const [inputValues, setInputValues] = useState({
    houseValue: 100000,
    savingsValue: 0,
    depositValue: 15,
    yearsToSaveValue: 0,
    monthsToSaveValue: 0
  });

  const monthOptions = [
    { key: '0', value: 0, text: '0 months' },
    { key: '1', value: 1, text: '1 month' },
    { key: '2', value: 2, text: '2 months' },
    { key: '3', value: 3, text: '3 months' },
    { key: '4', value: 4, text: '4 months' },
    { key: '5', value: 5, text: '5 months' },
    { key: '6', value: 6, text: '6 months' },
    { key: '7', value: 7, text: '7 months' },
    { key: '8', value: 8, text: '8 months' },
    { key: '9', value: 9, text: '9 months' },
    { key: '10', value: 10, text: '10 months' },
    { key: '11', value: 11, text: '11 months' },
  ]

  const yearOptions = [
    { key: '0', value: 0, text: '0 years' },
    { key: '1', value: 1, text: '1 year' },
    { key: '2', value: 2, text: '2 years' },
    { key: '3', value: 3, text: '3 years' },
    { key: '4', value: 4, text: '4 years' },
    { key: '5', value: 5, text: '5 years' },
    { key: '6', value: 6, text: '6 years' },
    { key: '7', value: 7, text: '7 years' },
    { key: '8', value: 8, text: '8 years' },
    { key: '9', value: 9, text: '9 years' },
    { key: '10', value: 10, text: '10 years' },
    { key: '11', value: 11, text: '11 years' },
    { key: '12', value: 12, text: '12 years' },
    { key: '13', value: 13, text: '13 years' },
    { key: '14', value: 14, text: '14 years' },
    { key: '15', value: 15, text: '15 years' },
    { key: '16', value: 16, text: '16 years' },
    { key: '17', value: 17, text: '17 years' },
    { key: '18', value: 18, text: '18 years' },
    { key: '19', value: 19, text: '19 years' },
    { key: '20', value: 20, text: '20 years' },
    { key: '21', value: 21, text: '21 years' },
    { key: '22', value: 22, text: '22 year' },
    { key: '23', value: 23, text: '23 years' },
    { key: '24', value: 24, text: '24 years' },
    { key: '25', value: 25, text: '25 years' },
    { key: '26', value: 26, text: '26 years' },
    { key: '27', value: 27, text: '27 years' },
    { key: '28', value: 28, text: '28 years' },
    { key: '29', value: 29, text: '29 years' },
    { key: '30', value: 30, text: '30 years' },
    { key: '31', value: 31, text: '31 years' },
    { key: '32', value: 32, text: '32 years' },
    { key: '33', value: 33, text: '33 year' },
    { key: '34', value: 34, text: '34 years' },
    { key: '35', value: 35, text: '35 years' },
    { key: '36', value: 36, text: '36 years' },
    { key: '37', value: 37, text: '37 years' },
    { key: '38', value: 38, text: '38 years' },
    { key: '39', value: 39, text: '39 years' },
    { key: '40', value: 40, text: '40 years' },
  ]

  const gtmConfig = 'https://www.principality.co.uk';

  useEffect(() => {
    window.parent.postMessage('pageview~/virtual/principality/mortgage-deposit-calculator', gtmConfig);
  }, [])

  const gtmSend = (eventLabel, value) => {
    window.parent.postMessage('event~MortgageDepositCalculator~' + eventLabel + '~' + value, gtmConfig);
  }

  const houseValueChange = (event) => {
    let inputVal = event.target.value;
    inputVal.toString();
    let newStringVal = inputVal.replace(/^0+/, "");
    let val = newStringVal.replace(/[^0-9]+/g, "");
    setInputValues({ ...inputValues, houseValue: val });
  }

  const savingsValueChange = (event) => {
    let inputVal = event.target.value;
    inputVal.toString();
    let newStringVal = inputVal.replace(/^0+/, "");
    let val = newStringVal.replace(/[^0-9]+/g, "");
    setInputValues({ ...inputValues, savingsValue: val });
  }

  const yearsToSaveChange = (event, { value }) => {
    setInputValues({ ...inputValues, yearsToSaveValue: value });
    gtmSend('3_yearsToSave', value)
  }

  const monthsToSaveChange = (event, { value }) => {
    setInputValues({ ...inputValues, monthsToSaveValue: value });
    gtmSend('4_monthsToSave', value)
  }

  const depositValueChange = (event) => {
    setInputValues({ ...inputValues, depositValue: event.target.value });
  }

  const handleKeyPress = (event) => {
    if ((event.which !== 8 && event.which !== 0) && (event.which < 48 || event.which > 57)) {
      event.preventDefault();
    }
  }

  return (
    <div className="calculator">

      <h1>House saving calculator</h1>
      <div className="calculator-inner">
        <label>What is the house value? <strong><CurrencyFormat value={+inputValues.houseValue} displayType={'text'} thousandSeparator={true} prefix={'£'} /></strong></label>

        <Input
          label="£"
          type="text"
          inputMode="numeric"
          value={inputValues.houseValue}
          min={0}
          maxLength={10}
          placeholder="100000"
          onKeyPress={handleKeyPress}
          onChange={houseValueChange}
          onKeyUp={() => gtmSend('1_houseValue', inputValues.houseValue)}
          pattern="[0-9]*"
        />

        <label>How much do you currently have saved? <strong><CurrencyFormat value={+inputValues.savingsValue} displayType={'text'} thousandSeparator={true} prefix={'£'} /></strong></label>

        <Input
          label="£"
          type="text"
          value={inputValues.savingsValue}
          min={0}
          maxLength={10}
          placeholder="0"
          inputMode="numeric"
          onKeyPress={handleKeyPress}
          onChange={savingsValueChange}
          onKeyUp={() => gtmSend('2_savingsValue', inputValues.savingsValue)}
          pattern="[0-9]*"
        />

        <label>
          How long do you have to save?
            </label>

        <div className="ui-input-wrapper">

          <div className="ui input">
            <Dropdown
              placeholder='Years'
              defaultValue={0}
              selection
              fluid
              options={yearOptions}
              onChange={yearsToSaveChange}
            />
          </div>

          <div className="ui input">
            <Dropdown
              placeholder='Months'
              defaultValue={0}
              selection
              fluid
              options={monthOptions}
              onChange={monthsToSaveChange}
            />
          </div>
        </div>

        <label>How much (%) do you need for a deposit?
        <strong> {inputValues.depositValue}%</strong></label>

        <input
          type="range"
          start={5}
          step={5}
          min={5}
          max={100}
          value={inputValues.depositValue}
          onChange={depositValueChange}
          onMouseUp={() => (gtmSend('5_depositValuePercentage', inputValues.depositValue))}
        />

      </div>

      <Results
        amount={inputValues.houseValue}
        savings={inputValues.savingsValue}
        deposit={inputValues.depositValue}
        years={inputValues.yearsToSaveValue}
        months={inputValues.monthsToSaveValue}
      />

    </div>
  );
}

export default Calculator;